import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CompanyNavbar from "./CompanyNavbar";

function PremiumMembershipCompany() {
  const log_id = Cookies.get("log_id");
  const [formData, setFormData] = useState({
    CompanyName: "",
    DirectorName: "",
    Email: "",
    ContactNumber: "",
    IndustryType: "",
    Subscription: "6month",
    Description: "",
  });

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await axios.get(
          `${url.path}/employeeCompanyPremiumDetails/${log_id}/`
        );
        if (response.data && response.data.Data) {
          setFormData((prevData) => ({
            ...prevData,
            ...response.data.Data,
          }));
        }
      } catch (error) {
        toast.error("Error fetching company details.");
        console.error("Error fetching company details:", error);
      }
    };

    if (log_id) {
      fetchCompanyDetails();
    }
  }, [log_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requestData = {
      CompanyID: formData.CompanyID,
      log_id: log_id,
      CompanyName: formData.CompanyName,
      PackageTaken: formData.Subscription,
      Description: formData.Description,
    };

    try {
      await axios.post(
        `${url.path}/employeeCompanyPremiumSubscribe/`,
        requestData
      );
      toast.success("Subscription request sent successfully!");
      setFormData((prevData) => ({
        ...prevData,
        Description: "",
      }));
    } catch (error) {
      toast.error("Error submitting subscription.");
      console.error("Error submitting subscription:", error);
    }
  };

  return (
    <div>
      <CompanyNavbar />
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="max-w-lg mx-auto bg-white shadow-lg rounded-lg p-6 mt-6">
        <h1 className="text-2xl font-bold text-center mb-4">
          Premium Membership
        </h1>

        <form onSubmit={handleSubmit} className="space-y-4">
          {[
            "CompanyName",
            "DirectorName",
            "Email",
            "ContactNumber",
            "IndustryType",
          ].map((field) => (
            <div key={field}>
              <label className="block text-sm font-semibold">
                {field.replace(/([A-Z])/g, " $1")}
              </label>
              <input
                type="text"
                name={field}
                value={formData[field]}
                readOnly
                className="w-full p-2 border rounded bg-gray-100"
              />
            </div>
          ))}

          <div>
            <label className="block text-sm font-semibold">Subscription</label>
            <div className="flex space-x-4">
              {["6month", "1year"].map((option) => (
                <label key={option} className="flex items-center space-x-2">
                  <input
                    type="radio"
                    name="Subscription"
                    value={option}
                    checked={formData.Subscription === option}
                    onChange={handleChange}
                    className="w-4 h-4"
                  />
                  <span>{option === "6month" ? "6 Months" : "1 Year"}</span>
                </label>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-semibold">Description</label>
            <textarea
              name="Description"
              value={formData.Description}
              onChange={handleChange}
              className="w-full p-2 border rounded h-24"
              placeholder="Enter any additional details..."
            />
          </div>

          <button
            type="submit"
            className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700 transition"
          >
            Send
          </button>
        </form>
      </div>
    </div>
  );
}

export default PremiumMembershipCompany;
